<template>
  <div
    class="
      container-fluid
      blog-container
      d-flex
      align-items-center
      justify-content-center
      mt-5
    "
  >
    <div class="col-xl-12">
      <div class="row blog-row p-4">
        <div class="col-md-12">
          <h1 class="blog-title main-heading-1-gradient mt-4 text-center ptb-2">
            SITEMAP
          </h1>
          <ul class="main-content-2 sitemap-list">
            <li @click="$router.push({ path: '/' })">Home</li>
            <li @click="$router.push({ path: '/search/search' })">Search</li>
            <li>Country</li>
            <ul>
              <li
                v-for="(country, index) in getCountries"
                :key="'country ' + index"
                @click="
                  e =>
                    $router.push({
                      name: 'CountryAbout',
                      params: { country_key: country.country_key }
                    })
                "
              >
                {{ country.country_key }}
              </li>
            </ul>
            <li>
              Services
              <ul>
                <li @click="$router.push({ path: '/career-counseeling' })">
                  Career Counselling
                </li>
                <li @click="$router.push({ path: '/abroad-conselling' })">
                  Study Abroad Counselling
                </li>
                <li @click="$router.push({ path: '/ielts' })">
                  IELTS Coaching
                </li>
                <li @click="$router.push({ path: '/edgeout' })">Edge Out</li>
                <li @click="$router.push({ path: '/franchise-locations' })">Branch Location</li>
                <!-- <li @click="$router.push({ path: '/franchise' })">Franchise</li> -->


              </ul>
            </li>
            <li @click="$router.push({ path: '/about-us' })">About Us</li>
            <li>
              Resources
              <ul>
                <li
                  @click="
                    $router.push({
                      path:
                        '/blog/foreign-education-consultants-the-steppingstone-to-successfully-studying-abroad/'
                    })
                  "
                >
                  Aliff Blogs
                </li>
              </ul>
            </li>
            <li @click="$router.push({ path: '/contact-us' })">Connect</li>
            <li>Login</li>
            <li>Register</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeServices from "@/apiServices/homeServices";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Header",
  data() {
    return {
      countries: []
    };
  },
  computed: {
    ...mapGetters(["getCountries"])
  },
  methods: {
    ...mapActions(["onGetCountries"])
    // async getCountries() {
    //   try {
    //     const response = await homeServices.getCountries();
    //     console.log(response.data);
    //     if (response.data.status) {
    //       this.countries = response.data.data;
    //     }
    //   } catch (err) {
    //     console.log("Error in getting getCountries ", err);
    //   }
    // },
  },
  beforeMount() {
    this.onGetCountries();
  }
};
</script>
<style>
.sitemap-list {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Sitemap.vue